'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { ColumnLayout } from 'product-card/types'
import { type ReactNode, createContext, useMemo, useState } from 'react'
import { PageType } from 'types/analytics'

export interface ProductCardConsumerLayoutContextProps {
	columnsLayout: ColumnLayout
	setColumnsLayout: (columnsLayout: ColumnLayout) => void
	isOnPLP: boolean
	isOneColumn: boolean
	isTwoColumns: boolean
	isFourColumns: boolean
}

interface ProductCardConsumerLayoutProviderProps {
	initialColumnsLayout: ColumnLayout
	children: ReactNode
}

export const ProductCardConsumerLayoutContext =
	createContext<ProductCardConsumerLayoutContextProps | null>(null)

export const ProductCardConsumerLayoutProvider = ({
	children,
	initialColumnsLayout,
}: ProductCardConsumerLayoutProviderProps) => {
	const { pageType } = useMasterData()
	const [columnsLayout, setColumnsLayout] = useState(initialColumnsLayout)

	const isOnPLP = !!columnsLayout && pageType !== PageType.Favorites
	const isOneColumn = columnsLayout === ColumnLayout.OneColumn
	const isTwoColumns = columnsLayout === ColumnLayout.TwoColumns
	const isFourColumns = columnsLayout === ColumnLayout.FourColumns

	const values = useMemo(
		() => ({
			columnsLayout,
			setColumnsLayout,
			isOnPLP,
			isOneColumn,
			isTwoColumns,
			isFourColumns,
		}),
		[columnsLayout]
	)

	return (
		<ProductCardConsumerLayoutContext.Provider value={values}>
			{children}
		</ProductCardConsumerLayoutContext.Provider>
	)
}
